import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DatazoomService } from '../../../analytics/datazoom/service/datazoom.service';
import { FireboltService } from '../firebolt.service';
import { NewrelicEvent } from 'qp-newrelic';
import { NewrelicService } from 'src/app/analytics/newrelic/service/newrelic.service';

@Injectable()
export class ExitConfirmationService {
  private showPopup = new BehaviorSubject(false);
  private isOpen = false;

  get isExitConfirmationOpen(): boolean {
    return this.isOpen;
  }

  constructor(private datazoom: DatazoomService, private fireboltService: FireboltService, private newrelic: NewrelicService) {}

  showExitConfirmation(): void {
    this.showPopup.next(true);
    this.isOpen = true;
  }

  closeExitConfirmation(): void {
    this.isOpen = false;
    this.showPopup.next(false);
  }

  listenExitConfirmation(): Observable<boolean> {
    return this.showPopup.asObservable();
  }

  closeApp(): void {
    this.datazoom.stop();
    this.newrelic.sendEvent(NewrelicEvent.APP_BACKGROUND);
    this.datazoom.reportBackground();
    this.fireboltService.exit();
    // if (navigator.userAgent.includes('Tizen')) {
    //   tizen?.application.getCurrentApplication().exit();
    // } else {
    //   window.close();
    // }
  }
}
